module.exports = __webpack_public_path__ + "img/icon-4.83ea3272.png";